import styled, { css } from 'styled-components';
// eslint-disable-next-line import/no-cycle
import { BANNER_TYPES } from './index';

const baseStyles = css`
  border: 1px solid ${({ theme }) => theme.kallisto.color.common.black[200]};
`;

const infoStyles = css`
  background-color: ${({ theme }) => theme.kallisto.color.common.semantic.info[50]};
  border: 1px solid ${({ theme }) => theme.kallisto.color.common.semantic.info[500]};
  color: ${({ theme }) => theme.kallisto.color.common.semantic.info[500]};
`;

const getTypeStyles = (type: BANNER_TYPES) => {
  switch (type) {
    case BANNER_TYPES.INFO:
      return infoStyles;
    case BANNER_TYPES.BASE:
    default:
      return baseStyles;
  }
};

export const ToggleBannerToggler = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  > label {
    padding: 12px 16px;
    background-color: white;
    border-radius: 8px;
    color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};

    > span {
      margin-right: calc(16px + 3px);
    }
  }

  @media (max-width: 767px) {
    margin-top: 8px;
    padding: 0;
    width: 100%;

    > label {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }
`;

export const ToggleBannerContainer = styled.div<{
  type: BANNER_TYPES;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  border-radius: 8px;
  padding: 16px;
  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};
  margin-bottom: 16px;
  width: 100%;

  ${({ type }) => type && getTypeStyles(type)};

  @media (max-width: 767px) {
    flex-direction: column;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  svg {
    flex-shrink: 0;
    margin-right: 16px;
  }
`;
